var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.wrapper},_vm._l((_vm.stats),function(ref){
var rateRange = ref.rateRange;
var percentage = ref.percentage;
return _c('StatLine',{key:rateRange,class:_vm.$style.statLine,attrs:{"intervals":_vm.getInterval(rateRange),"percentage":percentage}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }